import React, { useState, useEffect } from "react";
import ServicesSection from "../Dashboard/ServicesTab/ServicesTab";
import PatientSearch from "../../components/PatientSearch/PatientSearch";
import {
  useNavigate,
  useLocation,
  useParams,
  useLoaderData,
} from "react-router-dom";
import PharmacyTabs from "../../components/PharmacyTabs/PharmacyTabs";
import PharmacyHeaderDetails from "../../components/PharmacyHeaderDetails/PharmacyHeaderDetails";
import useTitanApp from "../../hooks/useTitanApp";
import CustomLoader from "../../components/controls/CustomLoader";
import Header from "../../components/Header/Header";
import DarkThemeButton from "../../components/DarkThemeButton";
import AsyncRendererRouter from "../../components/AsyncRendererRouter/AsyncRendererRouter";
import LoadingComponentKanban from "../../components/LoadingComponentKanban/LoadingComponentKanban";
import { setIsNewClinicComponent } from "../../dispatchers/pharmacyServiceDispatchers";

const LoadingComponent = () => {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};

  return (
    <div className="kanban-loader">
      <LoadingComponentKanban />
    </div>
  );
};

export default function PharmacyServices() {
  const { appState } = useTitanApp();
  const {
    currentPharmacy,
    features,
    isValidOrg,
    currentPharmacyId,
    isAppLoading,
    isTabLoading,
    darkMode,
    pharmacies,
    user,
  } = appState || {};
  const navigate = useNavigate();
  const { ifMapEnabled, ifPatientListEnabled, ifPharmacyDashboardEnabled } =
    features || {};

  const location = useLocation();
  const { pharmacyId } = useParams() || {
    pharmacyId: currentPharmacyId || "00000000-0000-0000-0000-000000000000",
  };

  const handlePatientIconClick = location.state;
  const serviceType = location.state && location?.state?.serviceType;
  const [getServicesCount, setGetServicesCount] = useState(0);
  const [isSearchIconClicked, setSearchIconClicked] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      // Update the screenWidth state on window resize
      setScreenWidth(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const handleCrossIconClick = () => {
    setSearchIconClicked(false); // Set the state to false when the cross icon is clicked
  };

  const [value, setValue] = React.useState(
    ifMapEnabled === true &&
      ifPharmacyDashboardEnabled === true &&
      ifPatientListEnabled === true
      ? 3
      : ifMapEnabled === false &&
        ifPharmacyDashboardEnabled === true &&
        ifPatientListEnabled === true
      ? 2
      : ifMapEnabled === true &&
        (ifPharmacyDashboardEnabled === true || ifPatientListEnabled === true)
      ? 2
      : ifMapEnabled === true ||
        ifPharmacyDashboardEnabled === true ||
        ifPatientListEnabled === true
      ? 1
      : 0
  );

  const handleChange = (event, newValue) => {
    if (value !== newValue) {
      setValue(newValue);
    }
  };

  function setupNavigations() {
    const navigations = [];

    // if (ifMapEnabled === true) {
    //   setIsNewClinicComponent(false);
    //   navigations.push(`/`);
    // }

    // if (ifPharmacyDashboardEnabled === true) {
    //   navigations.push(`/pharmacy/dashboard/${pharmacyId}`);
    // }

    // if (ifPatientListEnabled === true) {
    //   navigations.push(`/pharmacypatient/${pharmacyId}`);
    // }

    navigations.push(`/pharmacy/services/${pharmacyId}`);

    return navigations;
  }

  useEffect(() => {
    document.body.className = `${darkMode ? "dark-theme" : "light-theme"}`;
  }, []);

  const handleSettingsClick = () => {
    navigate(`/settings/general`);
  };

  useEffect(() => {
    const navigations = setupNavigations();
    if (value >= 0 && value < navigations?.length) {
      const toNavigate = navigations[value];
      const currentPath = location.pathname;
      toNavigate !== currentPath && navigate(toNavigate);
    }
  }, [value]);

  const { appData } = useLoaderData() || {};
  appData?.then((data) => {
    handleChange(
      null,
      ifMapEnabled === true &&
        ifPharmacyDashboardEnabled === true &&
        ifPatientListEnabled === true
        ? 3
        : ifMapEnabled === false &&
          ifPharmacyDashboardEnabled === true &&
          ifPatientListEnabled === true
        ? 2
        : ifMapEnabled === true &&
          (ifPharmacyDashboardEnabled === true || ifPatientListEnabled === true)
        ? 2
        : ifMapEnabled === true ||
          ifPharmacyDashboardEnabled === true ||
          ifPatientListEnabled === true
        ? 1
        : 0
    );
    return data;
  });

  return (
    <AsyncRendererRouter
      isLoading={isTabLoading}
      resolve={appData}
      loadingElement={<LoadingComponent />}
    >
      <div className="pharmacy_header_modal">
        <div className="modal-content map-blur">
          {/* <div className="tabs_box top-tabs">
            <PharmacyTabs
              value={value}
              handleChange={handleChange}
              getServicesCount={getServicesCount}
            />
            <PharmacyHeaderDetails />
            {screenWidth > 600 && (
              <Header
                onDarkModeChange={darkMode}
                ifSettingEnabled={ifSettingEnabled}
                handleSettingsClick={handleSettingsClick}
                isPharmacyMergeEnabled={false}
                isToggleBottombarEnabled={false}
                isSettingsEnabled={true}
                isChatEnabled={true}
                isListViewEnabled={false}
              />
            )}
          </div> */}

          <div
            className={`pharmacy-details-area services-details-area ${
              darkMode === false ? "" : "map-blur-black"
            }`}
          >
            {user?.role !== null &&
            isAppLoading === false &&
            isValidOrg &&
            currentPharmacy ? (
              <ServicesSection serviceType={serviceType} />
            ) : isAppLoading === false &&
              isValidOrg &&
              currentPharmacy &&
              pharmacyId === currentPharmacyId ? (
              <ServicesSection serviceType={serviceType} />
            ) : (
              <div className="overview_tab">
                <div className="overview_col-1">
                  Pharmacy services do not exist.
                </div>
              </div>
            )}
          </div>
        </div>
        {/* {isSearchIconClicked && (
          <div className="patientSearchModal">
            <PatientSearch
              show={isSearchIconClicked}
              setShow={isSearchIconClicked}
              handlePatientIconClick={handlePatientIconClick}
              handleCrossIconClick={handleCrossIconClick}
              pharmacyId={pharmacyId}
            />
          </div>
        )} */}
      </div>
    </AsyncRendererRouter>
  );
}
